import React from "react";
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import "./department.scss";
const DepartmentInformation = (props) => {
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const intitalState = {
            departmentName: "",
            departmentCode: "",
            description: "",
            amount: null,
            activeStatus: true,
            CreatedBy: getUserValue?.uniqueID
            
    }
    let location = useLocation();
    const navigate = useNavigate();
    const { submitDepartmentInfo } = props
    const [departmentInfoInputFields, setdepartmentInfoInputFields] = React.useState(intitalState);

    const handleDepartmentInfoInputChange = (event) => {
        const { name, value } = event.target;
        setdepartmentInfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const handleGoBack = () => {
        navigate("/master/department", { state: { addPatient: false, rowData: {} } })
    }
   const handleDepartement = (event, departmentInfoInputFields) => {
    submitDepartmentInfo(event, departmentInfoInputFields)
    setdepartmentInfoInputFields(intitalState)
   }
    return (
        <>
            
            <form>
                <div className="department-info" >
                    <div className="mt-2 ml-4">
                        <h4>Department Information</h4>
                        <div className="back-btn" onClick={handleGoBack}>
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Department Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fas fa-user-md"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Department Name" name="departmentName" 
                                        value={departmentInfoInputFields?.departmentName} 
                                        onChange={handleDepartmentInfoInputChange} required />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Department Code*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fas fa-user-md"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Department Code" name="departmentCode" 
                                        value={departmentInfoInputFields?.departmentCode} 
                                        onChange={handleDepartmentInfoInputChange} required />
                                </div>
                            </div>
                        </div>
                        
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Amount</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><CurrencyRupeeIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="amount" 
                                        placeholder="Amount" name="amount" 
                                        min="0"
                                        value={departmentInfoInputFields?.amount} onChange={handleDepartmentInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fas fa-info"></i></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" 
                                        id="lname" 
                                        placeholder="Description" 
                                        name="description" 
                                        value={departmentInfoInputFields?.description} 
                                        onChange={handleDepartmentInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2" onClick={(event) => handleDepartement(event, departmentInfoInputFields)}>Add Department</Button>
                </div>
            </form>
        </>
    );
};

export default DepartmentInformation; 